import { render, staticRenderFns } from "./tableGeneric.vue?vue&type=template&id=9e598bd8&"
import script from "./tableGeneric.script.ts?vue&type=script&lang=ts&"
export * from "./tableGeneric.script.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports